var map = {
	"./cargo_ship_fast.svg": 579,
	"./cargo_ship_medium.svg": 9592,
	"./cargo_ship_side.svg": 5078,
	"./cargo_ship_slow.svg": 8282,
	"./commercial_fishing_boat_fast.svg": 4894,
	"./commercial_fishing_boat_medium.svg": 8195,
	"./commercial_fishing_boat_side.svg": 8293,
	"./commercial_fishing_boat_slow.svg": 7126,
	"./high_speed_craft_fast.svg": 5155,
	"./high_speed_craft_medium.svg": 7207,
	"./high_speed_craft_side.svg": 4450,
	"./high_speed_craft_slow.svg": 8243,
	"./law_enforcement_boat_fast.svg": 7680,
	"./law_enforcement_boat_medium.svg": 5948,
	"./law_enforcement_boat_side.svg": 8277,
	"./law_enforcement_boat_slow.svg": 2267,
	"./military_ship_fast.svg": 9669,
	"./military_ship_medium.svg": 4874,
	"./military_ship_side.svg": 6329,
	"./military_ship_slow.svg": 9342,
	"./older/cargo_ship_fast.svg": 2069,
	"./older/cargo_ship_medium.svg": 3978,
	"./older/cargo_ship_slow.svg": 635,
	"./older/sailboat_fast.svg": 5146,
	"./older/sailboat_medium.svg": 9651,
	"./older/sailboat_slow.svg": 857,
	"./other_fast.svg": 9205,
	"./other_medium.svg": 6275,
	"./other_side.svg": 7561,
	"./other_slow .svg": 2547,
	"./passenger_ship_fast.svg": 6239,
	"./passenger_ship_medium.svg": 8474,
	"./passenger_ship_side.svg": 3936,
	"./passenger_ship_slow.svg": 3262,
	"./pilot_boat_fast.svg": 5151,
	"./pilot_boat_medium.svg": 5182,
	"./pilot_boat_side.svg": 6070,
	"./pilot_boat_slow.svg": 5198,
	"./pleasure_craft_fast.svg": 9243,
	"./pleasure_craft_medium.svg": 3622,
	"./pleasure_craft_side.svg": 4682,
	"./pleasure_craft_slow.svg": 6760,
	"./sailboat_fast.svg": 3598,
	"./sailboat_medium.svg": 5659,
	"./sailboat_side.svg": 2764,
	"./sailboat_slow.svg": 4988,
	"./search_and_rescue_boat_fast.svg": 8937,
	"./search_and_rescue_boat_medium.svg": 878,
	"./search_and_rescue_boat_side.svg": 6131,
	"./search_and_rescue_boat_slow.svg": 940,
	"./tanker_ship_fast.svg": 6587,
	"./tanker_ship_medium.svg": 5800,
	"./tanker_ship_side.svg": 3748,
	"./tanker_ship_slow.svg": 395,
	"./towing_ship_fast.svg": 8984,
	"./towing_ship_medium.svg": 6304,
	"./towing_ship_side.svg": 9498,
	"./towing_ship_slow.svg": 4748,
	"./tug_fast.svg": 9987,
	"./tug_medium.svg": 7687,
	"./tug_side.svg": 2160,
	"./tug_slow.svg": 3235,
	"./unknown_fast.svg": 7866,
	"./unknown_medium.svg": 2984,
	"./unknown_side.svg": 3599,
	"./unknown_slow.svg": 602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6016;